import { render, staticRenderFns } from "./IntegrationsV2.vue?vue&type=template&id=180e7842&scoped=true"
import script from "./IntegrationsV2.vue?vue&type=script&lang=js"
export * from "./IntegrationsV2.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsV2.vue?vue&type=style&index=0&id=180e7842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e7842",
  null
  
)

export default component.exports